export default __webpack_public_path__ + "static/media/Group 312.6a1756cc.svg";